import { PageMargin } from '@core/data-access';

export const PDF_PRINT_OPTIONS_MARGIN: PageMargin = {
  left: '32px',
  top: '64px',
  right: '32px',
  bottom: '96px',
} as const;
